  // принимает год, который меняем и элемент, возвращает элемент с годом с одним символом италик
  export function changeHistoryYearItalic(year, element) {
    element.textContent = ""; // Очищаем элемент

    year.split("").forEach((char, i) => {
      const span = document.createElement(i !== 1 ? "span" : "i");
      span.textContent = char;
      element.insertAdjacentElement("beforeend", span);
    });
    
  }